import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RESTServiceV2 } from 'src/app/shared/services/rest.service.v2';

@Injectable({ providedIn: 'root' })
export class EarlyAdvanceService {
  constructor(private rest: RESTServiceV2) {}

  create(invoiceId: string, advanceType: string): Observable<any> {
    return this.rest.post('/early-advances', { invoiceId, advanceType });
  }
}
